import React, { useEffect, useState } from 'react';
import { UIContextEvent, WarsEvents, DisplayGameTransitionEvent } from '@playroomkit/pr-wars/events';
import { useManager } from '@src/contexts/WarsContext';
import { UIContextType } from '@playroomkit/pr-wars-data';
import View from '@components/View';
import ScalableWrapper from '@components/ScalableWrapper';
import './ContinueGame.css';

const ContinueGame: React.FC = () => {
  const [showUI, setShowUI] = useState(false);
  const manager = useManager();

  useEffect(() => {
    const handleUIContextEvent = (event: Event) => {
      let e = event as UIContextEvent,
        display = e.hasContext(UIContextType.CONTINUE) && manager.isHost();
      
      setShowUI(display);
    }

    document.addEventListener(WarsEvents.UIContextEvent, handleUIContextEvent);

    return () => {
      document.removeEventListener(WarsEvents.UIContextEvent, handleUIContextEvent);
    };

  }, [showUI]);

  const handleContinue = () => {
    document.dispatchEvent(new DisplayGameTransitionEvent(0));
    manager.continueGame();
    setShowUI(false);
  }

  if(!showUI) return null;
  
  return (
    <View className="continue-wrapper">
      <ScalableWrapper maintainAspectRatioBy="height" anchor="bottom-right" >
        <View className='continue-container'>
          <View enableEventCapturing>
            <button className="continue" onClick={handleContinue}>
              <img src="img/UI/Next_Round.png" alt="next round" className='icon' />
            </button>
          </View>
        </View>
      </ScalableWrapper>
  </View>
)}

export default ContinueGame;
